import { URI } from '@/config/config'

export default async ({ rootState }, { payload }) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    },
    body: JSON.stringify(payload)
  }

  try {
    const userLoginInfoResult = await fetch(`${URI}payment/bulk-pay-parking-takeout`, opts)
    const resultJson = await userLoginInfoResult.json()
    if (userLoginInfoResult.status !== 200) {
      return Promise.reject(resultJson)
    }

    return resultJson.result
  } catch (error) {
    return Promise.reject(error)
  }
}